import appointmentServiceSagas from 'modules/appointment/services/sagas';
import authServiceSagas from 'modules/auth/services/sagas';
import customerServiceSagas from 'modules/customer/services/sagas';
import settingServiceSagas from 'modules/settingService/services/sagas';
import settingStaffSagas from 'modules/settingStaff/services/sagas';
import { all } from 'redux-saga/effects';
import shopServiceSagas from 'services/shop/sagas';
export default function* rootSaga() {
  yield all([
    appointmentServiceSagas(),
    settingServiceSagas(),
    customerServiceSagas(),
    authServiceSagas(),
    shopServiceSagas(),
    settingStaffSagas(),
  ]);
}
